import Colorful from "mixins/colorful"

import "sweetalert2/dist/sweetalert2.css";

// set default wide settings for sweetalerts
export default function (controller) {
  Colorful.call(this);
  swal.setDefaults({
    confirmButtonColor: this.colors.blue
  })

  // Override confirm prompts
  window.confirm = function(message, callback, caption) {
    swal({
      title: '',
      html: message,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      showLoaderOnConfirm: true,
      allowOutsideClick: false
    }).then( (confirm) => {
      return true;
    }, (dismiss) => {
      return false;
    });
  }

  //Override the default confirm dialog by rails
  $.rails.allowAction = function(link){
    if (link.data("confirm") == undefined){
      return true;
    }
    $.rails.showConfirmationDialog(link);
    return false;
  }

  //User click confirm button
  $.rails.confirmed = function(link){
    link.data("confirm", null);
    link.trigger("click.rails");
  }

  //Display the confirmation dialog
  $.rails.showConfirmationDialog = function(link){
    var message = link.data("confirm");
    swal({
      html: message,
      type: 'warning',
      confirmButtonText: 'Sure',
      showCancelButton: true
    }).then(function(result){
      // Only proceed if user clicked "Sure"
      if (result.value === true) {
        $.rails.confirmed(link);
      }
    }).catch(function(dismiss) {
      // User cancelled or clicked outside - do nothing
      return false;
    });
  };  
}
